module.exports = __webpack_public_path__ + "img/SES_205428808.cece2575.jpg";